module.exports = __webpack_public_path__ + "static/turner-logo-4a774f55fa4408949073b38deaa6d0ab.png";